import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Footer, Navbar } from "../../components";
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../../constants/apiConstants';
import { formatDate, calculateDifference, dateMonthYears } from "./../Utils";

import "../../assets/css/bootstrap.min.css";
import "../../assets/css/fontawesome-all.min.css";
import "../../assets/css/slick.css";
import "../../assets/css/line-awesome.min.css";
import "../../assets/css/main.css";
import "../../assets/css/responsive.css";
import "../../css/Tabss.css"

// Importing assets
import ProfileImage from "../../assets/images/all/Instituteimage.png";
import NotificationIcon from "../../assets/images/icons/notification-bing-svgrepo-com 1.svg";
import octiconImage from "../../assets/images/icons/octicon_upload-16.svg"

import SearchIcon from "../../assets/images/all/search.svg";

import CommanInstitute from '../../components/CommanInstitute';
import CommonInstituteMob from '../../components/CommonInstituteMob';
import feddImage from '../../assets/images/all/fedd.png'
import EditImage from '../../assets/images/icons/edit-1-svgrepo-com.svg'
import uploadoptionImage from '../../assets/images/icons/octicon_upload-16.svg'
import emojiImage from '../../assets/images/icons/proicons_emoji.svg'
import iconResizeImage from '../../assets/images/icons/ion_resize-outline.svg'
import ZoomImage from '../../assets/images/icons/mingcute_zoom-in-line.svg'
import boxImage from '../../assets/images/icons/tabler_box-multiple.svg'
import mediaImage from '../../assets/images/icons/Frame 399.svg'

const InstituteCourse = (props) => {
    const [activeTab, setActiveTab] = useState("Videos");
    const [showModal, setShowModal] = useState(false);
    const [showModal1, setShowModal1] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
      const navigate = useNavigate();

    const [uploadedVideos, setUploadedVideos] = useState([]); // State to store uploaded videos
    const [videos, setVideos] = useState([]); // State to hold video data
    const [courses, setCourses] = useState([]); // State to hold video data
    const [posts, setPosts] = useState([]); // State to hold video data
    const [profileimg, setProfileimg] = useState("");
    const [profileData, setProfileData] = useState({
            full_name: "",
            email_id: "",
            username: "",
            location: "",
    });
    const [bioInfo, setBioInfo] = useState({
            bio_info: "",
    });
    const [formData, setFormData] = useState({
        postTitle: "",
        postDescription: "",
    });

    const [selectedFile, setSelectedFile] = useState(null);
    const handleMediaChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };


console.log("img url", Image_Base_Url);
    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    const handleUploadClick = () => {
        // alert("fjfjfj")
        setShowModal(true);
    };
    const handleUploadClick1 = () => {
        navigate('/instituteChennal')
        // alert("fjfjfj")
        // setShowModal1(true);
    };
    const closeModal1 = () => {
        setShowModal1(false);

    };
    const handleFileChange1 = (event) => {
        const file = event.target.files[0];
        if (file && file.type === "application/pdf") { // Check if the file is a PDF
            const fileURL = URL.createObjectURL(file); // Create a temporary URL for the PDF
            setUploadedFiles((prevFiles) => [
                ...prevFiles,
                { name: file.name, url: fileURL, type: "pdf" },
            ]); // Add to array
            setShowModal1(false); // Close the modal after file upload
        } else {
            alert("Please upload a valid PDF file."); // Alert for invalid file types
        }
    };

    const handlePostFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    const user_id = ACCESS_Log_In_User_Id();
    const role_id = ACCESS_Role_ID();
    const { id, flags } = useParams();
    const currentUserId = user_id ? user_id : id;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
    };

    // Handle CKEditor content change
    const handleEditorChange = (event, editor) => {
        setFormData({ ...formData, postDescription: editor.getData() });
    };

    const handleAboutEditorChange = (event, editor) => {
        setFormData({ ...formData, aboutDescription: editor.getData() });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formDataToSend = new FormData();
    
        // Append user_id and role_id fields
        formDataToSend.append("user_id", user_id);
        formDataToSend.append("role_id", role_id);

        // Append text fields
        formDataToSend.append("post_title", formData.postTitle);
        formDataToSend.append("post_description", formData.postDescription);
    
        // Append files if they exist
        if (selectedFile) {
          formDataToSend.append("file_name", selectedFile);
        }
    
        try {
            const response = await axios.post( `${API_BASE_URL}/createPostDetails`,
                formDataToSend,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data', // Explicitly set content type
                    },
                }
            );
            if (response.data.meta.code == 200) {
                const result = response.data.meta;
                alert(`Success: ${result.message}`);
            } else {
                alert("Failed to submit the form!");
            }
        } catch (error) {
          console.error("Error submitting the form:", error);
          alert("An error occurred!");
        }
    };
    

    // Add about info of institutes
    const handleAboutSubmit = async (e) => {
        e.preventDefault();
        const formDataToSend = new FormData();
    
        // Append user_id and role_id fields
        formDataToSend.append("user_id", user_id);
        formDataToSend.append("role_id", role_id);
        formDataToSend.append("info_description", formData.aboutDescription);
    
        try {
            const response = await axios.post( `${API_BASE_URL}/createInstituteInfoDetails`,
                formDataToSend,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data', // Explicitly set content type
                    },
                }
            );
            
            if (response.data.code == 200) {
                // const result = response.data;
                alert(`Success: ${response.data.message}`);
            } else {
                alert("Failed to submit the form!");
            }
        } catch (error) {
          console.error("Error submitting the form:", error);
          alert("An error occurred!");
        }
    };

    // Function to fetch video details
    const getVideoDetails = async () => {
        try {
        const response = await axios.get(`${API_BASE_URL}/getVideosDetails?user_id=${user_id}`);
        console.log(response.data.code);
        // if (response.data.code === 200) {
            setVideos(response.data); // Set video data
        // } else {
        //     // setError("Failed to fetch video details.");
        // }
        } catch (err) {
        console.error(err);
        // setError("An error occurred while fetching data.");
        } finally {
        // setLoading(false); // Stop loading indicator
        }
    };

    // Function to fetch course details
    const getCourseDetails = async () => {
        // alert(user_id)
        try {
        const response = await axios.get(`${API_BASE_URL}/getCoursesDetails?user_id=${user_id}`);
        console.log("ddddddd=====",response.data.code);
        // if (response.data.code === 200) {
            setCourses(response.data); // Set video data
        // } else {
        //     // setError("Failed to fetch video details.");
        // }
        } catch (err) {
        console.error(err);
        // setError("An error occurred while fetching data.");
        } finally {
        // setLoading(false); // Stop loading indicator
        }
    };

    // Function to fetch post details
    const getPostDetails = async () => {
        try {
        const response = await axios.get(`${API_BASE_URL}/getPostDetails?user_id=${user_id}`);
        console.log(response.data.code);
        // if (response.data.code === 200) {
            setPosts(response.data); // Set video data
        // } else {
        //     // setError("Failed to fetch video details.");
        // }
        } catch (err) {
        console.error(err);
        // setError("An error occurred while fetching data.");
        } finally {
        // setLoading(false); // Stop loading indicator
        }
    };

    const handleFileChange = async (event) => {
        const file = event.target.files[0]; // Get the selected file
        if (file) {
            // Create a temporary URL for the video (optional for previewing the video locally)
            const videoURL = URL.createObjectURL(file);
            setUploadedVideos((prevVideos) => [
                ...prevVideos,
                { name: file.name, url: videoURL },
            ]); // Update state to include the new video
    
            // Prevent default behavior (optional for forms)
            event.preventDefault();
    
            // Define the API endpoint
            const url = API_BASE_URL + '/createVideosPostDetails';
    
            // Create FormData object to send the file and additional data
            const formData = new FormData();
            formData.append("role_id", ACCESS_Role_ID()); // Add role ID
            formData.append("user_id", ACCESS_Log_In_User_Id()); // Add user ID
            formData.append("file_name", file); // Add the file itself
    
            console.log("FormData:", formData); // Debugging: Check the formData object
    
            // Axios configuration
            const config = {
                headers: { "Content-Type": "multipart/form-data" },
                maxContentLength: Infinity,
                maxBodyLength: Infinity,
  
                onUploadProgress: (progressEvent) => {
                    const progress = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    console.log("Upload Progress:", progress + "%");
                },
            };
    
            try {
                // Make the POST request
                const response = await axios.post(url, formData, config);
                console.log("Response:", response.data);
    
                // Handle successful upload (e.g., show a success message or close a modal)
                setShowModal(false);
            } catch (error) {
                console.error("Error uploading file:", error.response || error);
                // Optionally, show an error message to the user
            }
        }
    };

    const fetchProfile = async () => {
        // const user_id = ACCESS_Log_In_User_Id();
        axios.get(`${API_BASE_URL}/getprofileImgDetails?user_id=${currentUserId}`)
            .then(function (response) {
                // console.log("profile imahges ssss",response.data.code);
                if (response.data.code == 200) {
                    console.log(response.data.data[0]);
                    setProfileimg(response.data.data[0]);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const fetchPersonalInfoDetails = async () => {
        const user_id = ACCESS_Log_In_User_Id();
        axios.get(`${API_BASE_URL}/getpersonalInfoDetails?user_id=${currentUserId}`)
            .then(function (response) {
                // console.log(response);
                if (response.data.code == 200) {
                    // console.log(response.data.data[0]);
                    //setpersonalInfoDetails(response.data.data[0]);
                    setProfileData({
                        id: response.data.data[0]["id"],
                        full_name: response.data.data[0]["full_name"],
                        email_id: response.data.data[0]["email_id"],
                        username: response.data.data[0]["username"],
                        location: response.data.data[0]["location"],
                    });
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const fetchBioInfoDetails = async () => {
        const user_id = ACCESS_Log_In_User_Id();
        axios.get(`${API_BASE_URL}/getbioInfoDetails?user_id=${currentUserId}`)
            .then(function (response) {
                //console.log(response);
                if (response.data.code == 200) {
                    // console.log(response.data.data[0]);
                    //setbioInfoDetails(response.data.data[0]);
                    setBioInfo({
                        id: response.data.data[0]["id"],
                        bio_info: response.data.data[0]['bio_info'],
                    });
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const goToCourse = (id) => {
        navigate(`/InstituteEditChennal/${id}`); // or any route like `/course/${course.slug}`
    };

    // // Fetch data on component mount
    useEffect(() => {
        getVideoDetails();
        fetchProfile();
        fetchPersonalInfoDetails();
        fetchBioInfoDetails();
        getCourseDetails();
        getPostDetails();
    }, []);

    const closeModal = () => {
        setShowModal(false);
        setUploadedVideos([]);
    };

    /// Stream end
    console.log("streamDetailsstreamDetails", courses)
    // if (loading) return <div>Loading...</div>;
    // if (error) return <div>Error: {error}</div>;
    return (
        <div className="bg_dashboard">

            <div className="container">
                <div className="row">

                    <CommanInstitute />
                    <CommonInstituteMob />


                    <div className="col-sm-9 col-md-12 col-xl-9 px-md-5 ps-xl-5 ">
                        <div className="row mt-5">
                            <div className="col-md-9 ps-0">
                                <div className="search-box dashboard_search">
                                    <input type="text"
                                        className="common-input common-input--lg dashboard_search_input pill shadow-sm auto-suggestion-input"
                                        placeholder="Search" />
                                    <button type="submit" className="btn btn-main spl_burron  border-0"><img
                                        src={SearchIcon} alt="" /></button>
                                </div>
                            </div>
                            <div className="col-md-2 text-xl-center  mt-3">
                                <img src={NotificationIcon} alt="" />
                            </div>
                            <div className="col-md-1">
                                <div className="dashboard_profile ms-auto">
                                    <img src={profileimg && profileimg.profile_image_path ? `${Image_Base_Url}${profileimg.profile_image_path}` : ProfileImage} alt="" />
                                </div>
                            </div>
                        </div>
                        <div class="row px-0 py-4">
                            <h2 class="learm-tilte mb-4">Course Curriculum</h2>


                            <div class="row">

                                <div class="col-sm-3 col-md-3 col-lg-4 col-xl-2">
                                    <div class="boost_profile text-center mx-auto mx-lg-0">
                                        <img src={profileimg && profileimg.profile_image_path ? `${Image_Base_Url}${profileimg.profile_image_path}` : ProfileImage} alt="Institute profile"
                                            class="img-cover w-75 h-75" />
                                    </div>

                                </div>

                                <div class="col-sm-9 col-md-9 col-lg-8 col-xl-10 px-md-5 px-xl-2">

                                    <div class="row ps-3 ps-lg-4 ">
                                        <div class="col-sm-12 order-lg-0">
                                            <div class="d-flex justify-content-center justify-content-lg-between">
                                                <div class="text-center text-lg-start">
                                                    <h4 class="learm-tilte mb-0">{profileData['full_name']}</h4>
                                                    <span class="learm-tilte2">30k Followers</span>
                                                </div>
                                                <div class="text-end psotion_absoltu ">
                                                    <span class="learm-tilte2">Manage</span>
                                                </div>

                                            </div>
                                        </div>

                                        <div class="col-sm-12 order-lg-2 mt-3 mt-lg-0">
                                            <p class="course-description  text-center text-lg-start course-description_1 text-muted mt-xl-3">{bioInfo.bio_info}</p>
                                        </div>
                                    </div>


                                </div>



                                <div class="tab-content" id="pills-tabContent">



                                    <div className="tab-container">
                                        {["Videos", "Courses", "Posts", "About"].map((tab) => (
                                            <button
                                                key={tab}
                                                className={`tab ${activeTab === tab ? "active-tab" : ""}`}
                                                onClick={() => setActiveTab(tab)}
                                            >
                                                {tab}
                                            </button>
                                        ))}
                                    </div>

                                    <div className={`tab-pane ${activeTab === "Videos" ? "active show fade" : "fade"}`} id="pills-media" role="tabpanel"
                                        aria-labelledby="pills-media-tab">
                                        <div class="row" id="document-container">


                                            <div class="col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-4">
                                                <div
                                                    class="boost_cards d-flex  flex-column justify-content-center align-items-center">
                                                    <img src={octiconImage} alt="" />
                                                    {/* <button class="btn btn_cousre btn_boost py-2 mt-2 px-4">Upload</button> */}
                                                    <button
                                                        className="btn btn_cousre btn_boost py-2 mt-2 px-4"
                                                        onClick={handleUploadClick}
                                                    >
                                                        Upload
                                                    </button>
                                                </div>

                                            </div>
                                            {videos.length > 0 ? (
                                                        videos.map((video, index) => (
                                                            <div key={index} className="col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-4">
                                                                <div className="boost_cards">
                                                                    <video
                                                                        className="boost_imgs course_video"
                                                                        controls
                                                                        style={{ width: "100%", maxHeight: "200px", objectFit: "cover" }}
                                                                    >
                                                                        <source src={`${Image_Base_Url}${video.video_path}`} type="video/mp4" />
                                                                        Your browser does not support the video tag.
                                                                    </video>
        
                                                                    <div className="px-3" style={{ height: "20%" }}>
                                                                        <p
                                                                            className="font-16 fw-500 text-dark"
                                                                            style={{ lineHeight: "18px", fontSize: "16px" }}
                                                                        >
                                                                            {video.video_name}
                                                                        </p>
                                                                        {/* <p className="fw-500">Duration: Custom duration</p> */}
                                                                    </div>
        
                                                                    <div
                                                                        className="px-3 d-flex justify-content-between align-items-end pb-0"
                                                                        style={{ height: "25%" }}
                                                                    >
                                                                        
                                                                        {/* <button className="btn btn_cousre btn_boost py-1 mt-2 px-3">Boost</button> */}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div>No videos available.</div>
                                                    )}
                                                

                                            {uploadedVideos.length > 0 ? (
                                                uploadedVideos.map((video, index) => (
                                                    <div key={index} className="col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-4">
                                                        <div className="boost_cards">
                                                            <video
                                                                className="boost_imgs course_video"
                                                                controls
                                                                style={{ width: "100%", maxHeight: "200px", objectFit: "cover" }}
                                                            >
                                                                <source src={video.url} type="video/mp4" />
                                                                Your browser does not support the video tag.
                                                            </video>

                                                            <div className="px-3" style={{ height: "20%" }}>
                                                                <p
                                                                    className="font-16 fw-500 text-dark"
                                                                    style={{ lineHeight: "18px", fontSize: "16px" }}
                                                                >
                                                                    {video.name}
                                                                </p>
                                                                <p className="fw-500">Duration: Custom duration</p>
                                                            </div>

                                                            <div
                                                                className="px-3 d-flex justify-content-between align-items-end pb-0"
                                                                style={{ height: "25%" }}
                                                            >
                                                                <span className="font-20 pt-2">
                                                                    Edit <img className="pt-0" src={EditImage} width="25px" alt="" />
                                                                </span>
                                                                <button className="btn btn_cousre btn_boost py-1 mt-2 px-3">Boost</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <p className="text-center"></p>
                                            )}


                                        </div>

                                        {/* <div class="row text-end mb-3">
                                            <span class="learm-tilte2">View More</span>
                                        </div> */}
                                    </div>


                                    <div className={`tab-pane ${activeTab === "Courses" ? "active show fade" : "fade"}`} id="pills-document" role="tabpanel"
                                        aria-labelledby="pills-document-tab">
                                        <div class="row" id="document-container">


                                            <div class="col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-4">
                                                <div
                                                    class="boost_cards d-flex  flex-column justify-content-center align-items-center">
                                                    <img src={uploadoptionImage} alt="" />
                                                    <button class="btn btn_cousre btn_boost py-2 mt-2 px-4" onClick={handleUploadClick1}>Upload</button>
                                                </div>

                                            </div>

                                            {courses.length > 0 ? (
                                                courses.map((course, index) => (
                                                    <div key={index} className="col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-4">
                                                        <div className="boost_cards" onClick={() => goToCourse(course.id)}>
                                                
                                                        <img
  src={
    (() => {
      try {
        const parsed = JSON.parse(course.course_image_name);
        return Array.isArray(parsed)
          ? `${Image_Base_Url}${parsed[0]?.image_path}`
          : `${Image_Base_Url}${parsed}`;
      } catch {
        return `${Image_Base_Url}${course.course_image_path || course.course_image_name}`;
      }
    })()
  }
  alt={course.course_title}
/>


                                                            <div className="px-3" style={{ height: "20%" }}>
                                                                <p
                                                                    className="font-16 fw-500 text-dark"
                                                                    style={{ lineHeight: "18px", fontSize: "16px" }}
                                                                >
                                                                    {course.course_title}
                                                                </p>
                                                                {/* <p className="fw-500">Duration: Custom duration</p> */}
                                                            </div>

                                                            <div
                                                                className="px-3 d-flex justify-content-between align-items-end pb-0"
                                                                style={{ height: "25%" }}
                                                            >
                                                                
                                                                {/* <button className="btn btn_cousre btn_boost py-1 mt-2 px-3">Boost</button> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div>No course available.</div>
                                            )}

                                            {/* <div class="col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-4">
                                                <div class="boost_cards">
                                                    <img class="boost_imgs course_video" src={feddImage} alt="" />

                                                    <div class="px-3" style={{ height: "20%" }}>
                                                        <p class="font-16 fw-500 text-dark" style={{ lineHeight: '18px', fontSize: '16px' }}>The Complete
                                                            AP and College Physics Cou</p>
                                                        <p class="fw-500">9 mins</p>
                                                    </div>

                                                    <div class="px-3 d-flex justify-content-between align-items-end pb-0"
                                                        style={{ height: "25%" }}>

                                                        <span class="font-20 pt-2">Edit <img class="pt-0"
                                                            src={EditImage} width="25px"
                                                            alt="" /></span>
                                                        <button class="btn btn_cousre btn_boost py-1 mt-2 px-3">Publish</button>
                                                    </div>
                                                </div>

                                            </div> */}
                                            {/* <div class="col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-4">
                                                <div class="boost_cards">
                                                    <img class="boost_imgs course_video" src={feddImage} alt="" />

                                                    <div class="px-3" style={{ height: "20%" }}>
                                                        <p class="font-16 fw-500 text-dark" style={{ lineHeight: '18px', fontSize: '16px' }}>The Complete
                                                            AP and College Physics Cou</p>
                                                        <p class="fw-500">9 mins</p>
                                                    </div>

                                                    <div class="px-3 d-flex justify-content-between align-items-end pb-0"
                                                        style={{ height: "25%" }}>

                                                        <span class="font-20 pt-2">Edit <img class="pt-0"
                                                            src={EditImage} width="25px"
                                                            alt="" /></span>
                                                        <button class="btn btn_cousre btn_boost py-1 mt-2 px-3">Publish</button>
                                                    </div>
                                                </div>

                                            </div> */}

                                        </div>
                                        {/* <div class="row">

                                            <p class="profile_text_2 mb-2">Published Courses</p>

                                            <div class="col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-4">
                                                <div class="boost_cards">
                                                    <img class="boost_imgs course_video" src={feddImage} alt="" />

                                                    <div class="px-3" style={{ height: "20%" }}>
                                                        <p class="font-16 fw-500 text-dark" style={{ lineHeight: '18px', fontSize: '16px' }}>The Complete
                                                            AP and College Physics Cou</p>
                                                        <p class="fw-500">9 mins</p>
                                                    </div>

                                                    <div class="px-3 d-flex justify-content-end align-items-end pb-0"
                                                        style={{ height: "25%" }}>

                                                        <span class="font-20 pt-2 learm-tilte2"><img class="pt-0"
                                                            src={EditImage}
                                                            width="25px" alt="" /> Manage</span>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-4">
                                                <div class="boost_cards">
                                                    <img class="boost_imgs course_video" src={feddImage} alt="" />

                                                    <div class="px-3" style={{ height: "20%" }}>
                                                        <p class="font-16 fw-500 text-dark" style={{ lineHeight: '18px', fontSize: '16px' }}>The Complete
                                                            AP and College Physics Cou</p>
                                                        <p class="fw-500">9 mins</p>
                                                    </div>


                                                    <div class="px-3 d-flex justify-content-end align-items-end pb-0"
                                                        style={{ height: "25%" }}>

                                                        <span class="font-20 pt-2 learm-tilte2"><img class="pt-0"
                                                            src={EditImage}
                                                            width="25px" alt="" /> Manage</span>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-4">
                                                <div class="boost_cards">
                                                    <img class="boost_imgs course_video" src={feddImage} alt="" />

                                                    <div class="px-3" style={{ height: "20%" }}>
                                                        <p class="font-16 fw-500 text-dark" style={{ lineHeight: '18px', fontSize: '16px' }}>The Complete
                                                            AP and College Physics Cou</p>
                                                        <p class="fw-500">9 mins</p>
                                                    </div>


                                                    <div class="px-3 d-flex justify-content-end align-items-end pb-0"
                                                        style={{ height: "25%" }}>

                                                        <span class="font-20 pt-2 learm-tilte2"><img class="pt-0"
                                                            src={EditImage}
                                                            width="25px" alt="" /> Manage</span>
                                                    </div>
                                                </div>

                                            </div>

                                        </div> */}


                                        {/* <div class="row mb-3">
                                            <div class="text-end">
                                                <p class="learm-tilte2 text-end">View More</p>
                                            </div>
                                        </div> */}

                                    </div>


                                    <div className={`tab-pane ${activeTab === "Posts" ? "active show fade" : "fade"}`} id="pills-links" role="tabpanel" aria-labelledby="pills-links-tab">
                                        <div class="row" id="links-container">
                                        {posts.length > 0 ? (
                                                posts.map((post, index) => (
                                                    <div key={index} className="col-sm-4 col-md-6 col-lg-6 col-xl-4 mb-4">
                                                        <div className="boost_cards">
                                                            <img src={`${Image_Base_Url}${post.post_image_path}`} alt={post.post_title} />

                                                            <div className="px-3" style={{ height: "20%" }}>
                                                                <p
                                                                    className="font-16 fw-500 text-dark"
                                                                    style={{ lineHeight: "18px", fontSize: "16px" }}
                                                                >
                                                                    {post.post_title}
                                                                </p>
                                                                {/* <p className="fw-500">Duration: Custom duration</p> */}
                                                            </div>

                                                            <div
                                                                className="px-3 d-flex justify-content-between align-items-end pb-0" style={{ height: "25%" }} >
                                                                
                                                                {/* <button className="btn btn_cousre btn_boost py-1 mt-2 px-3">Boost</button> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div>No course available.</div>
                                            )}
                                            <div class="col-sm-12 mx-auto">
                                                <div class="feed_card card mb-3">
                                                <form onSubmit={handleSubmit} encType="multipart/form-data">
                                                    <div class="row">
                                                        
                                                        <div class="col-12">
                                                            {/* <div class="dashboard_feed_img text-center">
                                                                <img src={feddImage} alt="" />
                                                            </div> */}
                                                            <div className="col-sm-12 mt-4">
                                                                <label htmlFor="mediaUpload" className="profile_text_2 mb-3 learn-title2"> Upload Media Post</label>
                                                                <div className="position-relative">
                                                                    <input type="text" className="common-input common-input--md dash_borad_input_1" id="courseTitle" placeholder={selectedFile ? selectedFile.name : "No file selected"} maxLength="60" readOnly />
                                                                    <span className="character-count position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)', }} >
                                                                        <label htmlFor="mediaFile" className="media-btn" style={{ cursor: 'pointer' }}>
                                                                            <img className="me-2" src={mediaImage} alt="Media Icon" />
                                                                            <span>Media</span>
                                                                        </label>
                                                                        <input type="file" id="mediaFile" style={{ display: 'none' }} onChange={handleMediaChange}  name="postImage"/>
                                                                    </span>
                                                                </div>

                                                                <label className="note learm-tilte2 fw-500 font-14">
                                                                    Note: All files should be at least 720p and less than 4.0 GB.
                                                                </label>
                                                            </div>
                                                            <div class="col-sm-12 mx-auto mt-4">
                                                            <label for="courseTitle" className="profile_text_2 mb-3">Post Title</label>
                                                                <div class="position-relative">
                                                                <input type="text" className="common-input common-input--md dash_borad_input_1" id="postTitle" name="postTitle" value={formData.postTitle} onChange={handleChange} placeholder="e.g. The Complete AP & College Physics Cou" maxLength="60"/>
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-12 mx-auto mt-4">
                                                                <label for="courseTitle" className="profile_text_2 mb-3">Post Description</label>
                                                                <div class="position-relative">
                                                                    <CKEditor editor={ClassicEditor} config={{ height: "800px" }} onChange={handleEditorChange} />
                                                                    <span class="character-count position-absolute"
                                                                        style={{
                                                                            left: '10px',
                                                                            bottom: '10px',

                                                                        }}><img
                                                                            src={emojiImage}
                                                                            alt="" /></span>
                                                                    <span class="character-count position-absolute"
                                                                        style={{ right: '10px', bottom: "10px" }}>2000</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-3">
                                                        <div class="text-end">
                                                            <button className="btn btn_cousre bg-main-btn text-white py-2 px-4 fw-500 font-20" type="submit">Save</button>
                                                        </div>
                                                    </div>
                                                </form>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>

                                    <div className={`tab-pane ${activeTab === "About" ? "active show fade" : "fade"}`} id="pills-links" role="tabpanel" aria-labelledby="pills-links-tab">
                                        <div class="row" id="links-container">
                                            <div class="col-sm-12 mx-auto">
                                                <div class="feed_card card mb-3">
                                                <form onSubmit={handleAboutSubmit} encType="multipart/form-data">
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <div class="col-sm-12 mx-auto mt-4">
                                                                <label for="courseTitle" className="profile_text_2 mb-3">About us</label>
                                                                <div class="position-relative">
                                                                    <CKEditor editor={ClassicEditor} config={{ height: "800px" }} onChange={handleAboutEditorChange} />
                                                                    <span class="character-count position-absolute"
                                                                        style={{
                                                                            left: '10px',
                                                                            bottom: '10px',

                                                                        }}><img
                                                                            src={emojiImage}
                                                                            alt="" /></span>
                                                                    <span class="character-count position-absolute"
                                                                        style={{ right: '10px', bottom: "10px" }}>2000</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-3">
                                                        <div class="text-end">
                                                            <button className="btn btn_cousre bg-main-btn text-white py-2 px-4 fw-500 font-20" type="submit">Save</button>
                                                        </div>
                                                    </div>
                                                </form>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {showModal && (
                <div
                    className="modal fade show"
                    style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
                    tabIndex="-1"
                >
                    <div className="modal-dialog modal-lg upload_popup_medai">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={closeModal}
                                ></button>
                            </div>
                            <div className="modal-body d-flex justify-content-center align-items-center">
                                <div className="text-center">
                                    <p className="upload_media_titlle mb-3">Select files to share</p>

                                    {/* File Input */}
                                    <input
                                        type="file"
                                        id="fileInput"
                                        accept="video/*"
                                        style={{ display: "none" }}
                                        onChange={handleFileChange}
                                    />

                                    {/* Trigger File Input */}
                                    <button
                                        type="button"
                                        className="btn btn_cousre"
                                        onClick={() => document.getElementById("fileInput").click()}
                                    >
                                        Upload from device
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showModal1 && (
                <div
                    className="modal fade show"
                    style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
                    tabIndex="-1"
                >
                    <div className="modal-dialog modal-lg upload_popup_medai">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={closeModal1}
                                ></button>
                            </div>
                            <div className="modal-body d-flex flex-column align-items-center">
                                <div className="text-center">
                                    <p className="upload_media_titlle mb-3">Select files to share</p>

                                    {/* File Input */}
                                    <input
                                        type="file"
                                        id="fileInput"
                                        accept="application/pdf"
                                        style={{ display: "none" }}
                                        onChange={handleFileChange1}
                                    />

                                    {/* Trigger File Input */}
                                    <button
                                        type="button"
                                        className="btn btn_cousre"
                                        onClick={() => document.getElementById("fileInput").click()}
                                    >
                                        Upload from device
                                    </button>
                                </div>

                                {/* Display Uploaded Files */}

                            </div>
                        </div>
                    </div>
                </div>
            )}



            {/* Footer */}
            <Footer />
        </div>
    );
};

export default InstituteCourse;






